import { BaseHttpService } from './base-http-service'
import { Stile, Term } from '@/types/product'

class StilesService extends BaseHttpService {
    STILE_DATA: Stile[] = []

    public async getStileTermsByDoorWidth(doorWidth: number) {
        if(this.STILE_DATA.length === 0) {
            await this.getStiles()
        }
        
        let width = Math.floor(doorWidth)

        let stilesForWidth: Stile | undefined
        while (!stilesForWidth && width <= 48) {
            stilesForWidth = this.STILE_DATA.find((x: any) => x.doorWidth === width)
            width++
        }

        return (stilesForWidth) ? this.buildTerms(stilesForWidth) : []

    }

    public doesProductHaveStiles(product_name: string, base_door_text: string):Boolean {
        const bdt = base_door_text.toLowerCase()
        const name = product_name.toLowerCase()

        // b = bifold (no stiles) --- wb, xb, zb = buck doors (yes stiles)
        const bifold = bdt.includes('b') && (!bdt.includes('wb') && !bdt.includes('xb') && !bdt.includes('zb'))

        return (!bifold && !name.includes('exterior') && !name.includes('fire'))
    }

    buildTerms(stile: Stile):Term[] {
        const terms: Term[] = []

        if(stile.standardWidthValue) {
            terms.push({
                id: stile.id,
                name: stile.standardWidthDisplay,
                slug: stile.standardWidthValue.toString()
            })
        }
        if(stile.additionalWidthValue && stile.additionalWidthDisplay) {
            terms.push({
                id: stile.id * 100, // Multiplied in order to be unique from standard above. https://www.notion.so/Stiles-f457fe104f1247f49cdacc723fc383a1?pvs=4
                name: stile.additionalWidthDisplay,
                slug: stile.additionalWidthValue.toString()
            })
        }

        return terms
    }

    async getStiles() {
        const result = await this.doApiGet<Stile[]>(`/website-options/stiles`)
        this.STILE_DATA = result?.response || []
    }
}

export default function useStilesService() {
    return new StilesService()
}
